export const editIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 14.38v3.12h3.13l9.2-9.22-3.12-3.12-9.22 9.22zm14.76-8.5c.32-.33.32-.85 0-1.18L15.3 2.74c-.33-.32-.85-.32-1.18 0L12.6 4.27l3.12 3.12 1.53-1.52z"/></svg>`,
  name: 'edit',
};
